export default "__VITE_ASSET__CfQ0_Bp5__"